import application from "stimulus_application";
import { definitionsFromContext } from "stimulus/webpack-helpers";
import "./faq_utility_toggle.css";


const context = require.context("./", true, /_controller\.js$/);
application.load(definitionsFromContext(context));